import { useEffect, useRef } from 'react'
import { useAppDispatch } from './redux-hook'
import { hideAlert, showAlert } from '../redux/features/notification/alert-slice'
const broadcastChannel = new BroadcastChannel('duplicate-tab-channel')

export const useDuplicateTabIdentifier = () => {
  const dispatch = useAppDispatch()
  const tabIdRef = useRef<string>(Math.random().toString(36).substring(2, 9))
  const activeTabIdRef = useRef<string | null>(null)

  useEffect(() => {
    const announceActiveTab = () => {
      broadcastChannel.postMessage({ type: 'ACTIVE_TAB', tabId: tabIdRef.current })
      activeTabIdRef.current = tabIdRef.current
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        announceActiveTab()
      }
    }

    const getPopup = () =>
      showAlert({
        id: 'duplicate-tab',
        title: 'Active Tab Changed',
        description: 'Another tab has become active. Do you want to make this tab active?',
        type: 'warning',
        onPrimaryClick: () => {
          broadcastChannel.postMessage({ type: 'ACTIVE_TAB', tabId: tabIdRef.current })
          activeTabIdRef.current = tabIdRef.current
          dispatch(hideAlert())
        }
      })

    const handleMessage = (event: MessageEvent) => {
      const { type, tabId } = event.data
      if (type === 'ACTIVE_TAB') {
        if (tabId !== tabIdRef.current) {
          activeTabIdRef.current = tabId
          dispatch(getPopup())
        } else {
          dispatch(hideAlert())
        }
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    broadcastChannel.addEventListener('message', handleMessage)

    if (document.visibilityState === 'visible') {
      announceActiveTab()
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      broadcastChannel.removeEventListener('message', handleMessage)
    }
  }, [dispatch])
}
